import { render, staticRenderFns } from "./HeaderUserUnsigned.vue?vue&type=template&id=6b4df510&scoped=true"
import script from "./HeaderUserUnsigned.vue?vue&type=script&lang=ts"
export * from "./HeaderUserUnsigned.vue?vue&type=script&lang=ts"
import style0 from "./HeaderUserUnsigned.vue?vue&type=style&index=0&id=6b4df510&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4df510",
  null
  
)

export default component.exports